export enum PortinTypeEnum {
    PREPAID = 'prepaid',
    POST_SIMPLE = 'post_simple',
    POST_COMPLEX = 'post_complex'
}